import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const provider = {
  name: 'Dr. Lauren Martinez, MD',
  addressLine1: '4400 W. Research Parkway',
  addressLine2: 'Suite 210, San Diego, CA 92121',
};

export default function CustomerAssignProvider() {
  const [isReviewing, setIsReviewing] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsReviewing(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Container disableGutters sx={{ mt: 0 }}>
      <Box
        sx={{
          maxWidth: 'md',
          mx: 'auto',
          textAlign: 'left',
          pt: { xs: 0.5, md: 0.5 },
          pb: { xs: 0.5, md: 0.5 },
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
        }}
      >
        <Card
          sx={{
            border: '1px solid #97999B',
            borderRadius: 2,
            boxShadow: '0 18px 40px rgba(0, 0, 0, 0.08)',
          }}
        >
          <CardContent sx={{ p: { xs: 2, md: 2.5 } }}>
            <Typography variant="h4" component="h1">
              Assign Provider
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              We are matching you with a licensed provider to review your intake and confirm test fit.
            </Typography>

            <Card
              sx={{
                mt: 2,
                border: '1px solid #97999B',
                borderRadius: 2,
                boxShadow: 'none',
              }}
            >
              <CardContent sx={{ minHeight: 120, display: 'flex', alignItems: 'center' }}>
                {isReviewing ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <CircularProgress size={20} />
                    <Typography variant="body1">
                      Your information is being reviewed by a physician.
                    </Typography>
                  </Box>
                ) : (
                  <Box>
                    <Typography variant="subtitle2" component="p" sx={{ color: '#5C5F62' }}>
                      Assigned provider
                    </Typography>
                    <Typography variant="h6" component="h2" sx={{ mt: 0.5 }}>
                      {provider.name}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 0.5 }}>
                      {provider.addressLine1}
                    </Typography>
                    <Typography variant="body2">
                      {provider.addressLine2}
                    </Typography>
                  </Box>
                )}
              </CardContent>
            </Card>

            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                color="primary"
                component={RouterLink}
                to="/mock/customer-kit-purchase-confirmation"
                sx={{
                  fontWeight: 700,
                  letterSpacing: '0.02em',
                  boxShadow: '0 12px 22px rgba(0, 118, 127, 0.28)',
                  py: 1.1,
                  px: 3,
                }}
              >
                Continue to Confirmation and Payment
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
}
